'use strict';

/**
 * This client-side js file just acts as a wrapper for the site preference config toggles
 * that are outputted by Controller: Integrations-OutputIntegrationsConfig
 */
function getIntegrationSettings() {
  return window.CachedData.siteIntegrations;
}
module.exports = {
  getIntegrationSettings: getIntegrationSettings
};